import { debounce } from 'lodash-es'

export function useFormSession() {
  const fingerprint = useState('fingerprint', () => null)
  const firstName = useState('firstName', () => '')
  const lastName = useState('lastName', () => '')
  const email = useState('email', () => '')
  const phone = useState('phone', () => '')
  const dob = useState('dob', () => null)
  const rentAmount = useState('rentAmount', () => null)
  //const acknowledged = useState('acknowledged', () => false)

  const address = reactive({
    display: '',
    street: '',
    city: '',
    province: '',
    postcode: ''
  })

  onMounted(() => {
    fingerprint.value = localStorage.getItem('tgi_rp_fid') || ''
    firstName.value = sessionStorage.getItem('firstName') || ''
    lastName.value = sessionStorage.getItem('lastName') || ''
    email.value = sessionStorage.getItem('email') || ''
    phone.value = sessionStorage.getItem('phone') || ''
    dob.value = sessionStorage.getItem('dob') || null
    rentAmount.value = parseFloat(sessionStorage.getItem('rentAmount')) || null
    //acknowledged.value = sessionStorage.getItem('acknowledged') === 'true'

    address.display = sessionStorage.getItem('address_display') || ''
    address.street = sessionStorage.getItem('address_street') || ''
    address.city = sessionStorage.getItem('address_city') || ''
    address.province = sessionStorage.getItem('address_province') || ''
    address.postcode = sessionStorage.getItem('address_postcode') || ''
  })

  // referral tracking
  const sendReferralUpdate = debounce(() => {
    if (!fingerprint.value) return

    const payload = {
      fingerprint: fingerprint.value,
      fields: {
        firstName: firstName.value,
        lastName: lastName.value,
        email: email.value,
        phone: phone.value,
        dob: dob.value,
        rentAmount: rentAmount.value,
        //acknowledged: acknowledged.value,
        address_display: address.display,
        address_street: address.street,
        address_city: address.city,
        address_province: address.province,
        address_postcode: address.postcode
      }
    }

    // strip empty values (so we don't overwrite valid past data)
    const cleaned = Object.fromEntries(
      Object.entries(payload.fields).filter(([_, v]) => !isEmpty(v))
    )

    if (Object.keys(cleaned).length === 0) return

    $fetch(`${partnerApi()}/rentprotect/referral`, {
      method: 'PUT',
      body: {
        fingerprint: fingerprint.value,
        fields: cleaned
      },
      headers: {
        'Content-Type': 'application/json'
      }
    }).catch(err => {
      console.error('Failed to update referral tracking', err)
    })
  }, 800)

  // helper
  const isEmpty = (v) => {
    return v === null || v === undefined || (typeof v === 'string' && v.trim() === '')
  }

  // auto-sync changes
  const track = (key, value) => {
    sessionStorage.setItem(key, value ?? '')
    sendReferralUpdate()
  }

  watch(firstName, v => track('firstName', v))
  watch(lastName, v => track('lastName', v))
  watch(email, v => track('email', v))
  watch(phone, v => track('phone', v))
  watch(dob, v => track('dob', v))
  watch(rentAmount, v => track('rentAmount', v))
  //watch(acknowledged, v => track('acknowledged', v))

  watch(() => address.display, v => track('address_display', v))
  watch(() => address.street, v => track('address_street', v))
  watch(() => address.city, v => track('address_city', v))
  watch(() => address.province, v => track('address_province', v))
  watch(() => address.postcode, v => track('address_postcode', v))

  return {
    firstName,
    lastName,
    email,
    phone,
    dob,
    rentAmount,
    //acknowledged,
    address
  }
}

export function clearFormSession() {
  const keys = [
    'firstName',
    'lastName',
    'email',
    'phone',
    'dob',
    'rentAmount',
    //'acknowledged',
    'address_display',
    'address_street',
    'address_city',
    'address_province',
    'address_postcode'
  ]
  keys.forEach(k => sessionStorage.removeItem(k))
}
